import { Map } from 'immutable';

import { aiGenerated } from './ai';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';

export function pageTitle({ channel, operation, preview, state }) {
  switch (operation) {
    case OPERATIONS[channel].PAGE_TITLE.AI_GENERATED: {
      return aiGenerated({ attribute: ATTRIBUTE.PAGE_TITLE, channel, preview, state });
    }

    case OPERATIONS[channel].PAGE_TITLE.FIND_AND_REPLACE: {
      return {
        payload: Map({
          type: preview.getIn([ATTRIBUTE.PAGE_TITLE, 'operation']),
          value: Map({
            find: preview.getIn([ATTRIBUTE.PAGE_TITLE, FIND]),
            replace: preview.getIn([ATTRIBUTE.PAGE_TITLE, REPLACE]),
          }),
        }),
      };
    }

    default: {
      return {
        payload: Map({
          type: preview.getIn([ATTRIBUTE.PAGE_TITLE, 'operation']),
          value: preview.getIn([ATTRIBUTE.PAGE_TITLE, VALUE], ''),
        }),
      };
    }
  }
}
